<template>
    <v-container fluid class="mt-1">
        <v-row align="center" class="mb-2">
            <v-col cols="4">
                <v-select v-model="selected_quote" :items="quoteOptions" item-text="text" item-value="value"
                    label="Select Quote" clearable hide-details dense outlined placeholder="All Quotes"></v-select>
            </v-col>
            <v-col cols="8" style="text-align:right;">
                <v-btn color="#525A68" rounded dark elevation="0" class="mr-2" @click="organiser_itinerary_dialog = true">
                    Send Organiser Itinerary
                </v-btn>
                <v-btn color="#525A68" rounded elevation="0" class="mr-2" :disabled="isPrinting" :dark="!isPrinting" @click="printItinerary()">
                    {{ isPrinting ? 'Printing...' : 'Print' }}
                </v-btn>
                <br>
                <v-btn color="error" text rounded elevation="0" class="mt-5 mr-2"
                    @click="revert_dialog = true">
                    Revert to Default
                </v-btn>
            </v-col>
        </v-row>
        <br>
        <div id="itinerary" class="px-5" style="max-width:900px;margin:0 auto;">
            <!-- <v-row v-if="event.lead.event_type?.itinerary_header">
                <v-col cols="12">
                    <img :src="api_url + 'media/suppliers/images/' + event.lead.event_type.itinerary_header" style="width:100%;display:block;" />
                </v-col>
            </v-row> -->
            <v-row>
                <v-col cols="12">
                    <div style="font-family:'Arial';font-size:70px;font-weight:600;color:#3988AA;text-align:center;">
                        IT'S GONNA BE FUN
                    </div>
                    <div class="itinerary-title">{{ event.lead.first_name }}'s {{ event.lead.activity_type }} Itinerary
                    </div>
                    <div class="itinerary-subtitle">{{ $date(event.lead.start_date).format('MMMM D, YYYY') }} TO {{
                        $date(event.lead.end_date).format('MMMM D, YYYY') }}</div>
                </v-col>
            </v-row>
            <br>
            <v-row style="font-family: Manrope;text-align:center;" class="my-8">
                <v-col cols="3">
                    <small>GROUP LEADER</small><br>
                    <b style="text-transform: uppercase;color:black;">{{ event.lead.first_name }} {{
                        event.lead.last_name }}</b>
                </v-col>
                <v-col cols="3">
                    <small>CONTACT</small><br>
                    <b style="text-transform: uppercase;color:black;">{{ event.lead.phone || event.lead.email }}</b>
                </v-col>
                <v-col cols="3">
                    <small>ARRIVAL</small><br>
                    <b style="text-transform: uppercase;color:black;">
                        {{ $date(event.lead.start_date).format('MMMM D, YYYY') }}
                    </b>
                </v-col>
                <v-col cols="3">
                    <small>DEPARTURE</small><br>
                    <b style="text-transform: uppercase;color:black;">
                        {{ $date(event.lead.end_date).format('MMMM D, YYYY') }}
                    </b>
                </v-col>
            </v-row>
            <br>
            <v-row class="px-10" style="font-family:sans-serif;">
                <v-col cols="12">
                    <p style="font-size:20px;font-weight:600;">Dear
                        {{ event.lead.first_name }} {{ event.lead.last_name }},</p>
                    <br>
                    <p v-if="isPrinting" style="white-space:pre-line;">{{ event.itinerary_intro || defaultItineraryIntro }}</p>
                    <v-textarea
                        v-else
                        :value="event.itinerary_intro || defaultItineraryIntro"
                        @change="onIntroChange($event)"
                        outlined
                        hide-details
                        auto-grow
                        rows="8"
                        class="custom-text-field"
                    ></v-textarea>
                </v-col>
            </v-row>
            <br class="html2pdf__page-break">
            <br>
            <v-row class="px-5">
                <v-col cols="12" v-for="(build, index) in builds" :key="index">
                    <div :style="(index > 0 ? 'page-break-before:always;padding-top:20px;' : '') + 'page-break-inside:auto;break-inside:auto;'">
                        <div style="page-break-inside:avoid;break-inside:avoid;">
                            <div v-if="getBuildImage(build)" style="text-align:center;">
                                <img :src="getImageUrl(getBuildImage(build))"
                                    style="max-width:100%;max-height:260px;display:inline-block;" />
                            </div>
                            <div
                                style="font-family:'Arial';font-size:60px;font-weight:600;color:#3988AA;text-align:center;height:90px;text-transform:uppercase;">
                                {{ build.type?.name }}
                            </div>
                            <div style="font-family:Manrope;text-transform:uppercase;text-align:center;color:black;"
                                v-if="build.type_id == 1">
                                {{ $date(build.start_date).format('dddd, MMMM D, YYYY') }} -
                                {{ $date(build.end_date).format('dddd, MMMM D, YYYY') }}
                            </div>
                            <div style="font-family:Manrope;text-transform:uppercase;text-align:center;color:black;" v-else>
                                {{ $date(build.start_date).format('dddd, MMMM D, YYYY') }}
                            </div>
                            <br><br>
                        </div>
                        <!-- Printing uses plain block rows (not a flex v-row/v-col grid) so html2pdf's
                             page-break-inside:avoid logic can correctly push a row to the next page
                             instead of cutting through its text. -->
                        <div v-if="isPrinting">
                            <div class="itinerary-row">
                                <div class="itinerary-row-label">
                                    <b>{{ build.type?.name }}:</b>
                                </div>
                                <div class="itinerary-row-value"><b>{{ getBuildName(build) }}</b></div>
                            </div>
                            <div class="itinerary-row" v-if="build.type_id == 1">
                                <div class="itinerary-row-label"><b>Accommodation Type:</b></div>
                                <div class="itinerary-row-value"><b>Self Catering Accommodation</b></div>
                            </div>
                            <div class="itinerary-row" v-if="build.venue">
                                <div class="itinerary-row-label"><b>Venue:</b></div>
                                <div class="itinerary-row-value"><b>{{ build.venue }}</b></div>
                            </div>
                            <template v-for="row in getRows(build)">
                                <div :class="['itinerary-row', row.key === 'description' ? 'itinerary-row-breakable' : '']" v-if="!row.hidden && row.value" :key="row.key">
                                    <div class="itinerary-row-label"><b>{{ row.label }}</b></div>
                                    <div class="itinerary-row-value">
                                        <b v-if="row.type === 'html'" v-html="row.value"></b>
                                        <b v-else>{{ row.value }}</b>
                                    </div>
                                </div>
                            </template>
                            <div class="itinerary-row" v-if="build.itinerary_notes">
                                <div class="itinerary-row-label"><b>Notes:</b></div>
                                <div class="itinerary-row-value"><b>{{ build.itinerary_notes }}</b></div>
                            </div>
                        </div>
                        <v-row v-else>
                            <v-col cols="4" class="itinerary-left">
                                <b>{{ build.type?.name }}:</b>
                            </v-col>
                            <v-col cols="8" class="itinerary-right"><b>{{ getBuildName(build) }}</b></v-col>
                            <template v-if="build.type_id == 1">
                                <v-col cols="4" class="itinerary-left"><b>Accommodation Type:</b></v-col>
                                <v-col cols="8" class="itinerary-right"><b>Self Catering Accommodation</b></v-col>
                            </template>
                            <v-col cols="4" class="itinerary-left"><b>Venue:</b></v-col>
                            <v-col cols="8" class="itinerary-right">
                                <v-text-field
                                    v-model="build.venue"
                                    @blur="saveVenue(build)"
                                    dense
                                    outlined
                                    hide-details
                                    class="custom-text-field"
                                ></v-text-field>
                            </v-col>
                            <template v-for="row in getRows(build)">
                                <template v-if="row.type === 'html'">
                                    <v-col cols="4" class="itinerary-left" :key="row.key + '-label'">
                                        <b>{{ row.label }}</b>
                                    </v-col>
                                    <v-col cols="8" class="itinerary-right" :key="row.key + '-value'">
                                        <div class="d-flex align-start itinerary-row-edit">
                                            <v-btn icon x-small class="mr-1 mt-1"
                                                @click="toggleRowHidden(build, row)"
                                                :title="row.hidden ? 'Show row' : 'Hide row'">
                                                <v-icon small :color="row.hidden ? '#B0B0B0' : '#3988AA'">{{
                                                    row.hidden ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
                                            </v-btn>
                                            <v-textarea
                                                :value="htmlToText(row.value)"
                                                @change="onRowValueChange(build, row, $event)"
                                                :disabled="row.hidden"
                                                dense
                                                outlined
                                                hide-details
                                                rows="2"
                                                auto-grow
                                                class="custom-text-field flex-grow-1"
                                            ></v-textarea>
                                        </div>
                                    </v-col>
                                </template>
                                <template v-else>
                                    <v-col cols="4" class="itinerary-left" :key="row.key + '-label'">
                                        <b>{{ row.label }}</b>
                                    </v-col>
                                    <v-col cols="8" class="itinerary-right" :key="row.key + '-value'">
                                        <div class="d-flex align-center itinerary-row-edit">
                                            <v-btn icon x-small class="mr-1"
                                                @click="toggleRowHidden(build, row)"
                                                :title="row.hidden ? 'Show row' : 'Hide row'">
                                                <v-icon small :color="row.hidden ? '#B0B0B0' : '#3988AA'">{{
                                                    row.hidden ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
                                            </v-btn>
                                            <v-text-field
                                                :value="row.value"
                                                @change="onRowValueChange(build, row, $event)"
                                                :disabled="row.hidden"
                                                dense
                                                outlined
                                                hide-details
                                                class="custom-text-field"
                                            ></v-text-field>
                                        </div>
                                    </v-col>
                                </template>
                            </template>
                            <v-col cols="4" class="itinerary-left"><b>Notes:</b></v-col>
                            <v-col cols="8" class="itinerary-right">
                                <v-textarea
                                    v-model="build.itinerary_notes"
                                    @blur="saveNotes(build)"
                                    dense
                                    outlined
                                    hide-details
                                    rows="2"
                                    auto-grow
                                    placeholder="Notes for this supplier (only shown once filled in)"
                                    class="custom-text-field"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>
            <v-row class="px-5">
                <v-col cols="12">
                    <div class="info-notice">
                        <div class="info-notice-header">
                            <b>PLEASE READ CAREFULLY</b> Check events and timings above. If we do not hear from you
                            within 3 days then we will consider the itinerary final.
                        </div>
                        <v-row class="mt-2">
                            <v-col cols="6" sm="3" class="info-notice-item" v-for="(item, index) in infoNoticeItems"
                                :key="index">
                                <div class="info-notice-icon">{{ item.icon }}</div>
                                <div class="info-notice-title">{{ item.title }}</div>
                                <div class="info-notice-text">{{ item.text }}</div>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>
        </div>
        <PreviewOrganiserItineraryEmail :show="organiser_itinerary_dialog" :lead="event.lead" :event="event"
            :company_id="get_selected_company.id" @close="organiser_itinerary_dialog = false">
        </PreviewOrganiserItineraryEmail>
        <v-dialog v-model="revert_dialog" max-width="480px">
            <v-card>
                <v-card-title>Revert to Default?</v-card-title>
                <v-card-text>
                    This will remove all event-specific changes made to this itinerary — including any rows you've
                    hidden or shown, any text you've overridden, venue entries, supplier notes, and the intro
                    message — and restore every supplier's default itinerary details. This cannot be undone.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="revert_dialog = false">Cancel</v-btn>
                    <v-btn color="error" dark :loading="revertingToDefault" @click="revertToDefault()">
                        Revert to Default
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapGetters } from "vuex"
import html2pdf from 'html2pdf.js'
import _ from 'lodash'
import PreviewOrganiserItineraryEmail from "./components/PreviewOrganiserItineraryEmail.vue"
import { resolveItineraryRows, getBuildName, htmlToText, DEFAULT_ITINERARY_INTRO } from "@/utils/itineraryRows"
import { buildInfoNoticeItems } from "@/utils/itineraryNotices"
import { dedupeLinkedBuilds } from "@/utils/linkedBuilds"

// Matches the quote builder's wizard step order (CustomQuote.vue's build_index_supplier_types)
// so same-day services appear in the same order the customer built them in. Accommodation
// (type_id 1) is pinned first wherever this is used as a sort key, since it spans the whole
// party rather than sitting on one day.
const BUILD_TYPE_ORDER = [1, 2, 6, 8, 4, 5, 3, 7]
const accommodationFirst = (build) => build.type_id === 1 ? 0 : 1

export default {
    components: {
        PreviewOrganiserItineraryEmail,
    },
    data: () => ({
        page_name: "Itinerary",
        classes: {
        },
        organiser_itinerary_dialog: false,
        revert_dialog: false,
        revertingToDefault: false,
        build_headers: [
            { text: 'Service', sortable: false, width: '25%' },
            { text: 'Rate', sortable: false, width: '10%' },
            { text: 'Day/s', sortable: false, width: '15%' },
            { text: 'Time', sortable: false, width: '25%' },
            { text: 'Groupsize', sortable: false, width: '25%' },
        ],
        open_panels: [0],
        api_url: null,
        selected_quote: null,
        isPrinting: false,
    }),
    created() {
    },
    async mounted() {
        this.api_url = process.env.VUE_APP_API_URL
        // const firstActive = this.event.quotes.find(q => q.is_activated)
        // if (firstActive) this.selected_quote = firstActive.id
    },
    computed: {
        ...mapGetters({
            get_selected_company: 'auth/get_selected_company',
            event: 'eventsStore/getSelectedEventGetter',
        }),
        infoNoticeItems() {
            return buildInfoNoticeItems(this.event.company)
        },
        quoteOptions() {
            return this.event.quotes
                .filter(quote => quote.is_activated)
                .map((quote, index) => ({
                    text: quote.name || `Quote ${index + 1}`,
                    value: quote.id,
                }))
        },
        builds() {
            const source = this.selected_quote
                ? this.event.quotes.filter(q => q.id === this.selected_quote)
                : this.event.quotes.filter(quote => quote.is_activated)
            let combined_builds = []
            source.forEach(quote => {
                combined_builds = combined_builds.concat(quote.builds)
            })
            // All activated quotes together: a build copied onto a variant quote appears once.
            return _.orderBy(dedupeLinkedBuilds(combined_builds), [accommodationFirst, 'start_date', (build) => BUILD_TYPE_ORDER.indexOf(build.type_id)], ['asc', 'asc', 'asc'])
        },
        defaultItineraryIntro() {
            return DEFAULT_ITINERARY_INTRO
        },
    },
    methods: {
        getImageUrl(image) {
            if (!image) return ''
            // If already a data URL (base64), use it directly
            if (image.startsWith('data:')) return image
            // Otherwise prepend the API path
            return this.api_url + 'media/suppliers/images/' + image
        },
        getBuildImage(build) {
            if (!build) return null
            if (build.type_id == 1) {
                return build.supplier?.image || build.supplier?.products?.[0]?.image || null
            }
            return build.option?.image || build.option?.product_type?.image || build.supplier?.image || null
        },
        async toBase64(url) {
            try {
                const filename = url.split('/').pop()
                const response = await this.$axios.get('admin/suppliers/image_base64', { filename })
                if (response.data?.response && response.data?.data) {
                    return response.data.data
                }
            } catch {
                // fall through to original url
            }
            return url
        },
        getRows(build) {
            return resolveItineraryRows(build, { formatDay: (date, fmt) => this.$date(date).format(fmt) })
        },
        getBuildName(build) {
            return getBuildName(build)
        },
        htmlToText(html) {
            return htmlToText(html)
        },
        toggleRowHidden(build, row) {
            const settings = { ...(build.itinerary_row_settings || {}) }
            const rowSetting = { ...(settings[row.key] || {}) }
            rowSetting.hidden = !row.hidden
            settings[row.key] = rowSetting
            this.$set(build, 'itinerary_row_settings', settings)
            this.saveRowSettings(build)
        },
        onRowValueChange(build, row, newValue) {
            const trimmed = (newValue || '').trim()
            // html rows are edited as text, so compare against the default's text
            const defaultValue = row.type === 'html' ? htmlToText(row.defaultValue) : (row.defaultValue || '')
            const settings = { ...(build.itinerary_row_settings || {}) }
            const rowSetting = { ...(settings[row.key] || {}) }
            if (!trimmed || trimmed === defaultValue) {
                delete rowSetting.value
            } else {
                rowSetting.value = trimmed
            }
            if (Object.keys(rowSetting).length === 0) {
                delete settings[row.key]
            } else {
                settings[row.key] = rowSetting
            }
            this.$set(build, 'itinerary_row_settings', settings)
            this.saveRowSettings(build)
        },
        async saveRowSettings(build) {
            try {
                await this.$axios.patch(`admin/quotes/quote_builds/${build.id}`, {
                    itinerary_row_settings: build.itinerary_row_settings,
                })
            } catch (error) {
                console.error('Failed to save itinerary row settings:', error)
            }
        },
        async saveNotes(build) {
            try {
                await this.$axios.patch(`admin/quotes/quote_builds/${build.id}`, {
                    itinerary_notes: build.itinerary_notes,
                })
            } catch (error) {
                console.error('Failed to save itinerary notes:', error)
            }
        },
        async saveVenue(build) {
            try {
                await this.$axios.patch(`admin/quotes/quote_builds/${build.id}`, {
                    venue: build.venue
                })
            } catch (error) {
                console.error('Failed to save venue:', error)
            }
        },
        async onIntroChange(newValue) {
            const trimmed = (newValue || '').trim()
            const value = trimmed && trimmed !== this.defaultItineraryIntro.trim() ? trimmed : null
            this.$set(this.event, 'itinerary_intro', value)
            try {
                await this.$axios.post(`admin/events/update_event/${this.event.id}`, {
                    company_id: this.get_selected_company.id,
                    itinerary_intro: value,
                })
            } catch (error) {
                console.error('Failed to save itinerary intro:', error)
            }
        },
        async revertToDefault() {
            this.revertingToDefault = true
            const allBuilds = (this.event.quotes || []).flatMap(quote => quote.builds || [])
            try {
                await Promise.all([
                    ...allBuilds.map(build => this.$axios.patch(`admin/quotes/quote_builds/${build.id}`, {
                        itinerary_row_settings: null,
                        itinerary_notes: null,
                        venue: null,
                    })),
                    this.$axios.post(`admin/events/update_event/${this.event.id}`, {
                        company_id: this.get_selected_company.id,
                        itinerary_intro: null,
                    }),
                ])
                allBuilds.forEach(build => {
                    this.$set(build, 'itinerary_row_settings', null)
                    this.$set(build, 'itinerary_notes', null)
                    this.$set(build, 'venue', null)
                })
                this.$set(this.event, 'itinerary_intro', null)
                this.$toast.success('Itinerary reverted to supplier defaults')
                this.revert_dialog = false
            } catch (error) {
                console.error('Failed to revert itinerary to defaults:', error)
                this.$toast.error('Failed to revert itinerary to defaults')
            } finally {
                this.revertingToDefault = false
            }
        },
        async printItinerary() {
            this.isPrinting = true
            try {
                await this.$nextTick()
                const el = document.getElementById('itinerary')
                const imgs = el.querySelectorAll('img')
                const origSrcs = []
                for (const img of imgs) {
                    origSrcs.push(img.src)
                    if (img.src && img.src.startsWith('http')) {
                        img.src = await this.toBase64(img.src)
                    }
                }
                const opt = {
                    margin: 0.1,
                    filename: this.event.name + '.pdf',
                    image: { type: 'jpeg', quality: 0.7 },
                    html2canvas: { useCORS: true, scale: 2, allowTaint: true, logging: false },
                    jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                    pagebreak: { mode: ['css', 'legacy'] }
                }
                await html2pdf().set(opt).from(el).save()
                imgs.forEach((img, i) => { img.src = origSrcs[i] })
            } finally {
                this.isPrinting = false
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.card-format {
    border-radius: 15px !important;

    .v-data-footer {
        background-color: #E9E9E9;
        color: #7C7C7C;
        font-family: 'Work Sans';
    }

    .v-data-footer__select .v-text-field {
        background-color: white;

        .v-select__slot {
            padding-left: 10px;
        }
    }
}

.custom-small {
    color: #7C7C7C;
    font-size: 12px;
    font-weight: 600;
}

:deep(.theme--light.v-data-table tbody td) {
    height: 80px;
    border: none;
}

.label-text-color {
    color: #7C7C7C;
}

.text-proper-case {
    text-transform: capitalize;
}

.search-text-field {
    margin-top: 15px;

    .v-input__slot {
        min-height: 0 !important;
        margin-top: 8px;
    }

    .v-input__prepend-inner {
        margin-top: 5px !important;
    }
}

:deep(.custom-buttons span) {
    text-transform: none;
    font-family: Manrope;
    font-size: 13px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: normal;
    box-shadow: none !important;
}

:deep(.custom-buttons button) {
    padding: 8px 7px 8px 7px !important;
    border-radius: 5px;
}

.paid_row {
    background-color: #FFF1F1 !important;
}


:deep(.custom-text-field) {
    legend {
        display: none;
    }

    fieldset {
        border-color: #D3D3D3 !important;
    }

    input,
    textarea {
        color: #101010;
        font-family: Manrope;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    &.v-input--is-disabled {
        fieldset {
            border-color: #E5E5E5 !important;
        }

        input,
        textarea {
            color: #ADADAD !important;
            -webkit-text-fill-color: #ADADAD;
        }
    }
}

::-webkit-scrollbar {
    width: 7px;
    background: white;
}

::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: #D9D9D9;
    color: #D9D9D9;
    height: 50px;
}

.itinerary-title {
    font-size: 32px;
    font-weight: 600;
    text-transform: uppercase;
    color: #FAAF3A;
    text-align: center;
    font-family: sans-serif;
}

.itinerary-subtitle {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    text-transform: uppercase;
    font-family: Manrope;
}

.itinerary-left {
    font-family: Montserrat;
    color: #3988AA;
    border-bottom: solid 1px #D3D3D3;
}

.itinerary-right {
    font-family: Manrope;
    color: black;
    border-bottom: solid 1px #D3D3D3;
}

.print-avoid-break {
    page-break-inside: avoid;
    break-inside: avoid;
}

.itinerary-row {
    display: flex;
    page-break-inside: avoid;
    break-inside: avoid;
}

.itinerary-row-breakable {
    page-break-inside: auto;
    break-inside: auto;
}

.itinerary-row-label {
    flex: 0 0 33.3333%;
    max-width: 33.3333%;
    box-sizing: border-box;
    padding: 12px;
    font-family: Montserrat;
    color: #3988AA;
    border-bottom: solid 1px #D3D3D3;
}

.itinerary-row-value {
    flex: 1 1 auto;
    max-width: 66.6666%;
    box-sizing: border-box;
    padding: 12px;
    font-family: Manrope;
    color: black;
    border-bottom: solid 1px #D3D3D3;
    word-break: break-word;
}

.itinerary-row-edit {
    .custom-text-field {
        flex: 1 1 auto;
    }
}

.info-notice {
    background: #EFEFEF;
    padding: 40px 10px 20px;
    margin-top: 50px;
    font-family: Manrope;
    page-break-inside: avoid;
    break-inside: avoid;
}

.info-notice-header {
    text-align: center;
    font-size: 13px;
    color: black;
}

.info-notice-item {
    padding: 25px 20px;
    text-align: center;
}

.info-notice-icon {
    font-size: 26px;
    margin-bottom: 8px;
}

.info-notice-title {
    font-weight: 700;
    color: black;
    font-size: 14px;
    margin-bottom: 6px;
}

.info-notice-text {
    color: #4D4D4D;
    font-size: 12px;
    line-height: 1.5;
}
</style>